module.exports = __webpack_public_path__ + "static/media/gasWrong.28cc71d2.png";